export function loadScript(src) {
  const id = hex_md5(src);
  return new Promise((resolve, reject) => {
    if (exist(id, src)) {
      Log('exist src', src);
      resolve(true);
    } else
      add(id, src, resolve, reject);
  })
}


function exist(id, src) {
  const nodeList = document.querySelectorAll('head script');
  for (let i = 0; i < nodeList.length; i++) {
    const node = nodeList[i];
    if (node.id === id || node.src.includes(src)) return true;
  }
  return false;
}

function add(id, src, resolve, reject) {
  Log('add script', src);
  const script = document.createElement('script');
  script.src = src;
  script.id = id;
  script.onload = script.onreadystatechange = function () {
    Log('add script success', src);
    script.onload = script.onreadystatechange = null;
    resolve(true);
  }
  script.onerror = function (e) {
    console.error(e);
    reject(e);
  }
  const head = document.getElementsByTagName("head")[0] || document.documentElement;
  head.appendChild(script);
}



// WEBPACK FOOTER //
// ./src/utils/loadScript.js